var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_2048_36921)" } }, [
        _c("path", {
          attrs: {
            d: "M8.375 8.12109C9.56847 8.12109 10.7131 7.64699 11.557 6.80307C12.4009 5.95916 12.875 4.81457 12.875 3.62109C12.875 2.42762 12.4009 1.28303 11.557 0.439113C10.7131 -0.4048 9.56847 -0.878906 8.375 -0.878906C7.18153 -0.878906 6.03693 -0.4048 5.19302 0.439113C4.34911 1.28303 3.875 2.42762 3.875 3.62109C3.875 4.81457 4.34911 5.95916 5.19302 6.80307C6.03693 7.64699 7.18153 8.12109 8.375 8.12109ZM6.76836 9.80859C3.30547 9.80859 0.5 12.6141 0.5 16.077C0.5 16.6535 0.967578 17.1211 1.54414 17.1211H15.2059C15.7824 17.1211 16.25 16.6535 16.25 16.077C16.25 12.6141 13.4445 9.80859 9.98164 9.80859H6.76836Z",
            fill: "#010A11",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_2048_36921" } }, [
          _c("rect", {
            attrs: {
              width: "16",
              height: "16",
              fill: "white",
              transform: "translate(0.5 0.121094)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }